<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="QA_display_settings"
          @click="submit"
        >設定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">表示設定</span>
        </div>
        <div class="popup-content">
          <ul class="popup-list">
            <li class="popup-list-item">
              <div class="formparts checkbox is-disable">
                <input type="checkbox" name="display_settings" id="display_settings_01">
                <label for="display_settings_01">タイトル<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </li>
            <li class="popup-list-item">
              <div class="formparts checkbox">
                <input type="checkbox" name="display_settings" id="display_settings_02" v-model="state.display.content">
                <label for="display_settings_02">本文<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </li>
            <li class="popup-list-item">
              <div class="formparts checkbox">
                <input type="checkbox" name="display_settings" id="display_settings_03" v-model="state.display.created">
                <label for="display_settings_03">作成日<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </li>
            <li class="popup-list-item">
              <div class="formparts checkbox">
                <input type="checkbox" name="display_settings" id="display_settings_04" v-model="state.display.modified">
                <label for="display_settings_04">更新日<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </li>
            <li class="popup-list-item">
              <div class="formparts checkbox">
                <input type="checkbox" name="display_settings" id="display_settings_05" v-model="state.display.user">
                <label for="display_settings_05">作成者<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </li>
          </ul>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive } from '@vue/composition-api'

export default defineComponent({
  setup (props, context) {
    const store = context.root.$store
    const { note } = store.state

    const state = reactive({
      display: {}
    })
    // 初期値
    Object.assign(state.display, note.display)

    const close = () => {
      context.emit('closeNoteSearchDisplaySettings')
    }
    const submit = () => {
      store.dispatch('note/setDisplay', state.display)
      context.emit('closeNoteSearchDisplaySettings')
    }

    return {
      state,
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
    &-1 {
      padding: 20px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid $color-line;
      position: relative;
      z-index: 2;
      .txt {
        display: inline-block;
        font-size: 1.4rem;
      }
      .formparts.select {
        font-size: 1.4rem;
        min-width: 140px;
        margin-left: 20px;
        input[type="text"] {
          width: 140px;
          padding-right: 40px;
        }
      }
    }
  }
  .popup-list {
    position: relative;
    z-index: 1;
  }
</style>
